export { default as UserAccount } from './containers/AccountContainer'



// WEBPACK FOOTER //
// ./src/UserAccount/index.js